import React, { useState } from 'react';
import Textbox from '../Textbox/Textbox';
import Tax_SelectButton from '../Tax_SelectButton/Tax_SelectButton';
import { FaTrash } from 'react-icons/fa';

const TableComponent = ({ onItemChange, onTotal, values }) => {

    const [items, setItems] = useState([{ description: '', quantity: 0, rate: 0, total: 0, discount: 0, taxKey: '', taxPercentage: 0 }]);

    const addLine = () => {
        setItems((prev) => [...prev, { description: '', quantity: 0, rate: 0, total: 0, discount: 0, taxKey: '', taxPercentage: 0 }]);
    }

    const handleChange = (index, key, value) => {
        const newItems = [...items];
        newItems[index][key] = value;
    
        // Recalculate total when quantity, rate, discount, or tax changes
        const baseTotal = newItems[index].quantity * newItems[index].rate;
        
        // Calculate discount amount and apply it
        const discountAmount = (newItems[index].discount / 100) * baseTotal;
    
        // Apply the discount: discounted total
        const discountedTotal = baseTotal - discountAmount;
    
        // Round the discounted total to 2 decimal places
        const roundedDiscountedTotal = Math.round(discountedTotal * 100) / 100;
    
        // Calculate tax amount based on the discounted total
        const taxAmount = (newItems[index].taxPercentage / 100) * roundedDiscountedTotal;
    
        // Round the tax amount to 2 decimal places
        const roundedTaxAmount = Math.round(taxAmount * 100) / 100;
    
        // Final total after applying both discount and tax
        const finalTotal = roundedDiscountedTotal + roundedTaxAmount;
    
        // Round the final total to 2 decimal places
        const roundedFinalTotal = Math.round(finalTotal * 100) / 100;

        // Update the item's total in state
        newItems[index].total = roundedFinalTotal;
    
        setItems(newItems);
        onItemChange(newItems);
    };
    
    const handleTaxChange = (index, taxKey, taxPercentage) => {
        const newItems = [...items];
        
        // Update the taxKey and taxPercentage directly in the item
        newItems[index].taxKey = taxKey;
        newItems[index].taxPercentage = taxPercentage;
    
        // Recalculate total with new tax percentage after discount
        const baseTotal = newItems[index].quantity * newItems[index].rate;
        
        // Calculate discount amount and apply it
        const discountAmount = (newItems[index].discount / 100) * baseTotal;
    
        // Apply the discount: discounted total
        const discountedTotal = baseTotal - discountAmount;
    
        // Round the discounted total to 2 decimal places
        const roundedDiscountedTotal = Math.round(discountedTotal * 100) / 100;
    
        // Calculate tax amount based on the discounted total
        const taxAmount = (newItems[index].taxPercentage / 100) * roundedDiscountedTotal;
    
        // Round the tax amount to 2 decimal places
        const roundedTaxAmount = Math.round(taxAmount * 100) / 100;
    
        // Final total after applying both discount and tax
        const finalTotal = roundedDiscountedTotal + roundedTaxAmount;
    
        // Round the final total to 2 decimal places
        const roundedFinalTotal = Math.round(finalTotal * 100) / 100;

        // Update the item's total in state
        newItems[index].total = roundedFinalTotal;
    
        setItems(newItems);
        onItemChange(newItems);
    };
    

    return (
        <div className="container mt-4">
            <div className="table-responsive">
                <table className="table table-bordered">
                    <thead>
                        <tr>
                            <th style={{ width: '35%' }} className="text-center">Description</th>
                            <th style={{ width: '15%' }} className="text-center" >Quantity</th>
                            <th style={{ width: '15%' }} className="text-center">Rate</th>
                            {onTotal ? <th style={{ width: '15%' }} className="text-center">Discount</th> : null}
                            {onTotal ? <th style={{ width: '15%' }} className="text-center">Tax</th> : null}
                            <th style={{ width: '15%' }} className="text-center">Total</th>
                            <th style={{ width: '20%' }} className="text-center">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {items.map((val, index) => (
                            <tr key={index}>
                                <td>
                                    <Textbox
                                        border="0"
                                        width="100%"
                                        height="50"
                                        placeholder="Enter Item Name"
                                        setValue={(value) => handleChange(index, 'description', value)}
                                    />
                                </td>
                                <td>
                                    <Textbox
                                        border="0"
                                        width="100%"
                                        height="50"
                                        placeholder="Enter Numbers only"
                                        valueshow={val.quantity}
                                        setValue={(value) => handleChange(index, 'quantity', value)}
                                    />
                                </td>
                                <td>
                                    <Textbox
                                        border="0"
                                        width="100%"
                                        height="50"
                                        placeholder="Enter Numbers only"
                                        setValue={(value) => handleChange(index, 'rate', value)}
                                    />
                                </td>
                                {onTotal ? 
                                <td>
                                    <Textbox
                                        border="0"
                                        width="50"
                                        height="50"
                                        placeholder="Enter Quantity Numbers only"
                                        setValue={(value) => handleChange(index, 'discount', value)}
                                    />
                                </td> : null}
                                {onTotal ? 
                                <td>
                                    <Tax_SelectButton
                                        values={values}
                                        height="50"
                                        width="100%"
                                        setTaxPercentage={(taxPercentage) => handleTaxChange(index, val.taxKey, taxPercentage)}
                                        setTaxName={(taxKey) => handleTaxChange(index, taxKey, values[taxKey])}
                                        border="10px"
                                        taxName={val.taxKey} 
                                        taxPercentage={val.taxPercentage} 
                                    />
                                </td> : null}
                                <td>
                                    <p className='mt-2'>{val.total.toFixed(2)}</p> 
                                </td>
                                <td>
                                    <FaTrash className='ms-5 mt-3 delete' onClick={() => {
                                        const newItems = items.filter((_, i) => i !== index);
                                        setItems(newItems);
                                    }}/>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <p onClick={addLine}><button>+</button></p>
        </div>
    );
};

export default TableComponent;
